import { render, staticRenderFns } from "./BankAccountDetails.vue?vue&type=template&id=33ff7238&scoped=true"
import script from "./BankAccountDetails.vue?vue&type=script&lang=js"
export * from "./BankAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./BankAccountDetails.vue?vue&type=style&index=0&id=33ff7238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff7238",
  null
  
)

export default component.exports